// extracted by mini-css-extract-plugin
module.exports = {"mobileAssetImage":"responsive-asset-image-module--mobileAssetImage--3zbAH","desktopAssetImage":"responsive-asset-image-module--desktopAssetImage--IcjMn"};